function toFiniteNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * Truncate toward zero at `maxDecimals` (never round up).
 * Used for limits/balances so displayed amounts never exceed what the user can spend.
 */
export function truncateToDecimals(value, maxDecimals = 8) {
  const n = toFiniteNumber(value);
  if (n === null) return 0;
  const places = Math.max(0, Math.floor(Number(maxDecimals) || 0));
  if (places === 0) return Math.trunc(n);
  const factor = 10 ** places;
  return Math.trunc(n * factor) / factor;
}

export function normalizeDecimalString(value, maxDecimals = 8) {
  const n = toFiniteNumber(value);
  if (n === null) return "0";
  if (n === 0) return "0";
  return String(truncateToDecimals(n, maxDecimals));
}

/** Locale string without unnecessary trailing fraction digits (truncated, not rounded). */
export function formatDisplayNumber(value, maxDecimals = 6) {
  const n = toFiniteNumber(value);
  if (n === null) return "0";
  const compact = truncateToDecimals(n, maxDecimals);
  return compact.toLocaleString(undefined, {
    maximumFractionDigits: maxDecimals,
    minimumFractionDigits: 0,
  });
}

export function formatDisplayUsd(value, maxDecimals = 2) {
  return formatDisplayNumber(value, maxDecimals);
}

export function formatDisplayPrice(value, maxDecimals = 6) {
  return formatDisplayNumber(value, maxDecimals);
}

export function formatDisplayTokenAmount(value, maxDecimals = 4) {
  return formatDisplayNumber(value, maxDecimals);
}

export function formatDisplayPaymentAmount(value, maxDecimals = 4) {
  return formatDisplayNumber(value, maxDecimals);
}

/** Parse on-chain integer amount to a JS number (e.g. wei → ether). */
export function fromBaseUnits(raw, baseDecimals = 18) {
  const n = Number(parseInt(String(raw ?? 0), 10)) / 10 ** baseDecimals;
  return Number.isFinite(n) ? n : 0;
}
